import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  if (request.context.get(BYPASS_AUTH)) return next(request);
  if (token)
    return next(
      request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`),
      })
    );
  else return next(request);
};

export const BYPASS_AUTH = new HttpContextToken(() => false);
